import React, { useState } from "react";
import { Text, HStack, Button } from "native-base";
import { Loc } from "../../App/Loc";
import AVCancel from "../common/AVCancel";
import AVInputtext from "../AVInputtext";
import { AddIcon } from "../../assets/icons/icon-assets";
import * as AV from "../../AVCore/AVCore";
import { setUser } from "../../Redux/Actions/userActions";
import { isMobile as isMobileDevice } from "react-device-detect";
import { Dimensions } from "react-native";
import {
  FacebookShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  PinterestShareButton,
  PinterestIcon,
  TelegramShareButton,
  TelegramIcon,
  RedditShareButton,
  RedditIcon,
  TumblrShareButton,
  TumblrIcon,
} from "react-share";
import { useSelector, useDispatch, RootStateOrAny } from "react-redux";

const InviteFriends = ({ showAddinviteModal, setshowAddinviteModal }) => {
  const dispatch = useDispatch();
  const emailRegex = /\S+@\S+\.\S+/;
  const phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  const [personName, setPersonName] = useState("");
  const [personEmail, setPersonEmail] = useState("");
  const [personPhone, setPersonPhone] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );

  const handleSendInvite = async () => {
    if (personEmail?.trim()?.length > 0) {
      if (!emailRegex.test(personEmail)) {
        return;
      }
    }
    setIsLoading(true);
    let contact: AV.IContact = {
      name: personName,
      email: personEmail,
      type: "Person",
      phone: personPhone,
    };
    let val = await AV.Person.createInvite([contact]);
    if (val) {
      console.log(val);
      dispatch(setUser(val));
    }
    setIsLoading(false);
    setPersonName("");
    setPersonEmail("");
    setPersonPhone("");
    //setshowAddinviteModal(false);
  };

  const [shareUrl, setshareUrl] = React.useState(window.location.origin);

  const socialShare = async () => {
    if (navigator.share) {
      let contact: AV.ITokenProcessRequest = {
        type: "Invite",
        entity: AV.AVEntity.getLink(currentUser),
      };
      let val: any = await AV.AVEntity.createTokenRequest(contact);
      var URL = `${window.location.origin}/${val?.type}/${val?.token}`;
      const shareData = {
        title: "",
        text: "Welcome to Actavivo",
        url: shareUrl,
      };
      try {
        await navigator.share(shareData);
        // resultPara.textContent = 'MDN shared successfully';
      } catch (err) {
        // resultPara.textContent = `Error: ${err}`;
      }
    } else {
      alert("cannot share ");
    }
  };
  const dimensions = Dimensions.get("window");
  const isMobile = dimensions?.width <= 600 || false;

  return (
    <div className="modal-blur">
      <div
        className={isMobile ? "modal-container-mobile" : "modal-container"}
        style={{ height: isMobile ? "275px" : "auto" }}
      >
        <div className="content">
          <div className="header">
            <Text fontSize={24}>{Loc.currentLang.menu?.inviteFriends}</Text>
            <AVCancel
              color={undefined}
              size={undefined}
              callback={() => setshowAddinviteModal(false)}
            />
          </div>

          <div className="body">
            {/*<div className="customInviteForm">*/}
            {/*  <AVInputtext*/}
            {/*    type={"text"}*/}
            {/*    label={Loc.currentLang.menu.personName}*/}
            {/*    // label={'Person Name *'}*/}
            {/*    onChange={(e) => setPersonName(e.target.value)}*/}
            {/*    value={personName}*/}
            {/*    size="small"*/}
            {/*    defaultValue={undefined}*/}
            {/*    width={undefined}*/}
            {/*    height={undefined}*/}
            {/*    minRows={undefined}*/}
            {/*    multiline={undefined}*/}
            {/*    maxLength={undefined}*/}
            {/*    min={undefined}*/}
            {/*    max={undefined}*/}
            {/*  />*/}
            {/*  <AVInputtext*/}
            {/*    type={"email"}*/}
            {/*    label={Loc.currentLang.menu.emailAddress}*/}
            {/*    onChange={(e) => setPersonEmail(e.target.value)}*/}
            {/*    value={personEmail}*/}
            {/*    size="small"*/}
            {/*    defaultValue={undefined}*/}
            {/*    width={undefined}*/}
            {/*    height={undefined}*/}
            {/*    minRows={undefined}*/}
            {/*    multiline={undefined}*/}
            {/*    maxLength={undefined}*/}
            {/*    min={undefined}*/}
            {/*    max={undefined}*/}
            {/*  />*/}
            {/*  <AVInputtext*/}
            {/*    type={"phone"}*/}
            {/*    label={Loc.currentLang.menu.phone}*/}
            {/*    onChange={(e) => setPersonPhone(e.target.value)}*/}
            {/*    value={personPhone}*/}
            {/*    size="small"*/}
            {/*    defaultValue={undefined}*/}
            {/*    width={undefined}*/}
            {/*    height={undefined}*/}
            {/*    minRows={undefined}*/}
            {/*    multiline={undefined}*/}
            {/*    maxLength={undefined}*/}
            {/*    min={undefined}*/}
            {/*    max={undefined}*/}
            {/*  />*/}
            {/*  <Button*/}
            {/*    bgColor={"AVColor.primary"}*/}
            {/*    borderRadius={"full"}*/}
            {/*    isLoading={isLoading}*/}
            {/*    width={"40px"}*/}
            {/*    height={"40px"}*/}
            {/*    isDisabled={*/}
            {/*      personName?.trim()?.length === 0 ||*/}
            {/*      personEmail?.trim()?.length === 0*/}
            {/*    }*/}
            {/*    onPress={() => handleSendInvite()}*/}
            {/*  >*/}
            {/*    <AddIcon size={"20px"} color="AVColor.white" />*/}
            {/*  </Button>*/}
            {/*</div>*/}

            <HStack
              alignItems={"center"}
              justifyContent={"center"}
              pt={10}
              pb={3}
            ></HStack>

            {isMobileDevice ? (
              <HStack justifyContent={"center"}>
                <Button
                  bgColor={"AVColor.primary"}
                  rounded="full"
                  px={8}
                  mb={2}
                  onPress={socialShare}
                >
                  Invite friends
                </Button>
              </HStack>
            ) : (
              <SocialShare />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const SocialShare = () => {
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const [shareUrl, setShareUrl] = React.useState(window.location.origin);

  React.useEffect(() => {
    const generateUrl = async () => {
      let contact: AV.ITokenProcessRequest = {
        type: "Invite",
        entity: AV.AVEntity.getLink(currentUser),
      };
      let val: any = await AV.AVEntity.createTokenRequest(contact);
      if (val?.token) {
        console.log(
          "ShareURL: ",
          `${window.location.origin}/${val.type}/${val.token}`,
        );
        setShareUrl(`${window.location.origin}/${val.type}/${val.token}`);
      }
    };
    if (currentUser) {
      generateUrl();
    }
  }, [currentUser]);

  const title = Loc.currentLang.post.inviteMessage;
  const body = Loc.currentLang.post.inviteMessage;
  const media =
    "https://play-lh.googleusercontent.com/gw09xDUsyBktV2HqNlBHf6xE7ICjlRwWBqi0vZ7IqQ2pRJVSVqF6nPuTcX9d5_Hmvw";

  return (
    <HStack
      alignItems="center"
      space={5}
      justifyContent="center"
      flexWrap="wrap"
    >
      {shareUrl && shareUrl !== window.location.origin && (
        <>
          <WhatsappShareButton url={shareUrl} title={title} separator=":: ">
            <WhatsappIcon size={35} round />
          </WhatsappShareButton>

          <FacebookShareButton url={shareUrl} quote={title}>
            <FacebookIcon size={35} round />
          </FacebookShareButton>

          <LinkedinShareButton
            url={shareUrl}
            title={title}
            summary={title}
            source={title}
          >
            <LinkedinIcon size={35} round />
          </LinkedinShareButton>

          <TwitterShareButton url={shareUrl} title={title}>
            <TwitterIcon size={35} round />
          </TwitterShareButton>

          <EmailShareButton
            url={shareUrl}
            subject={title}
            body={body}
            separator=": "
          >
            <EmailIcon size={35} round />
          </EmailShareButton>

          <PinterestShareButton
            url={shareUrl}
            media={media}
            description="description of the image"
          >
            <PinterestIcon size={35} round />
          </PinterestShareButton>

          <TelegramShareButton url={shareUrl} title={title}>
            <TelegramIcon size={35} round />
          </TelegramShareButton>

          <TumblrShareButton url={shareUrl} title={title}>
            <TumblrIcon size={35} round />
          </TumblrShareButton>
        </>
      )}
    </HStack>
  );
};

export default InviteFriends;
